<template>
  <component :is="wrapperTag">
    <div class="flex">
      <img
        v-if="!isDashboard"
        src="https://storage.googleapis.com/komerce/assets/svg/back.svg"
        alt="Komerce"
        class="mr-1 cursor-pointer"
        @click="handleRouterBack"
      >
      <strong class="text-black font-bold text-2xl mr-1">
        {{ title }}
      </strong>
      <img
        v-b-tooltip.hover.top="'Data dalam 150 hari terakhir'"
        src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
        alt="Komerce"
        class="cursor-pointer"
        variant="outline-primary"
      >
    </div>
    <BCard class="mt-1">
      <BRow class="justify-between items-center">
        <BCol
          md="auto"
          class="mb-2"
        >
          <BRow>
            <BCol
              v-for="(data, idx) in indicator"
              :key="idx"
              md="auto"
              class="flex items-center"
            >
              <img
                :src="data.img"
                alt="Komerce"
                style="margin-right: 5px"
              >
              <span class="text-black">{{ data.name }}</span>
            </BCol>
          </BRow>
        </BCol>
        <BCol
          v-if="!isDashboard"
          md="auto"
        >
          <BRow>
            <BCol
              md="auto"
              class="mb-1"
            >
              <BFormInput
                v-model="search"
                size="md"
                class="w-100"
                placeholder="Cari Kecamatan"
                style="width: 37%; margin-right: 10px"
                @input="searchDistrict"
              />
            </BCol>
          </BRow>
        </BCol>
      </BRow>
      <BOverlay
        :show="loading"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        rounded="sm"
      >
        <BTable
          :items="itemRasioRetur"
          :fields="fieldRasioRetur"
          show-empty
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          class="mt-1"
        >
          <template #cell(district_name)="data">
            {{ toUpperCase(data.value) }}, {{ toUpperCase(data.item.city_name) }}
          </template>
          <template #cell(jne)="data">
            <div
              v-for="(item, idx) in data.item.data"
              :key="idx"
            >
              <div
                v-if="item.ekspedisi === 'JNE'"
                class="flex items-center justify-evenly"
              >
                <img
                  :src="handleStatusIndicator(item.status)"
                  alt="Komerce"
                  class="mr-1"
                >
                <span :class="handleLabelPercentage(item.status)">
                  {{ item.percentage }} % ({{ `${item.retur}/${item.total}` }})
                </span>
              </div>
            </div>
          </template>
          <template #cell(ideexpress)="data">
            <div
              v-for="(item, idx) in data.item.data"
              :key="idx"
            >
              <div
                v-if="item.ekspedisi === 'IDEXPRESS'"
                class="flex items-center justify-evenly"
              >
                <img
                  :src="handleStatusIndicator(item.status)"
                  alt="Komerce"
                  class="mr-1"
                >
                <span :class="handleLabelPercentage(item.status)">
                  {{ item.percentage }} % ({{ `${item.retur}/${item.total}` }})
                </span>
              </div>
            </div>
          </template>
          <template #cell(sicepat)="data">
            <div
              v-for="(item, idx) in data.item.data"
              :key="idx"
            >
              <div
                v-if="item.ekspedisi === 'SICEPAT'"
                class="flex items-center justify-evenly"
              >
                <img
                  :src="handleStatusIndicator(item.status)"
                  alt="Komerce"
                  class="mr-1"
                >
                <span :class="handleLabelPercentage(item.status)">
                  {{ item.percentage }} % ({{ `${item.retur}/${item.total}` }})
                </span>
              </div>
            </div>
          </template>
          <template #cell(sap)="data">
            <div
              v-for="(item, idx) in data.item.data"
              :key="idx"
            >
              <div
                v-if="item.ekspedisi === 'SAP'"
                class="flex items-center justify-evenly"
              >
                <img
                  :src="handleStatusIndicator(item.status)"
                  alt="Komerce"
                  class="mr-1"
                >
                <span :class="handleLabelPercentage(item.status)">
                  {{ item.percentage }} % ({{ `${item.retur}/${item.total}` }})
                </span>
              </div>
            </div>
          </template>
          <template #cell(ninja)="data">
            <div
              v-for="(item, idx) in data.item.data"
              :key="idx"
            >
              <div
                v-if="item.ekspedisi === 'NINJA'"
                class="flex items-center justify-evenly"
              >
                <img
                  :src="handleStatusIndicator(item.status)"
                  alt="Komerce"
                  class="mr-1"
                >
                <span :class="handleLabelPercentage(item.status)">
                  {{ item.percentage }} % ({{ `${item.retur}/${item.total}` }})
                </span>
              </div>
            </div>
          </template>
          <template #cell(j&t)="data">
            <div
              v-for="(item, idx) in data.item.data"
              :key="idx"
            >
              <div
                v-if="item.ekspedisi === 'J&T'"
                class="flex items-center justify-evenly"
              >
                <img
                  :src="handleStatusIndicator(item.status)"
                  alt="Komerce"
                  class="mr-1"
                >
                <span :class="handleLabelPercentage(item.status)">
                  {{ item.percentage }} % ({{ `${item.retur}/${item.total}` }})
                </span>
              </div>
            </div>
          </template>
          <template #cell(average)="data">
            {{ data.item.average }} %
          </template>
          <template #cell(status)="data">
            <div
              :class="handleClassStatus(data.item.status)"
              style="border-radius: 20px"
            >
              {{ data.item.status }}
            </div>
          </template>
        </BTable>
      </BOverlay>
      <div
        v-if="isDashboard"
        style="color: #08a0f7; text-align: center; cursor: pointer"
        @click="$router.push('/analitics-returnarea')"
      >
        Lihat Selengkapnya
      </div>
    </BCard>
  </component>
</template>

<script>
import {
  BRow, BCol, BCard, BTable, BFormInput, BOverlay,
} from 'bootstrap-vue'
import IconVeryGood from '@/assets/images/svg/very-good.svg'
import IconGood from '@/assets/images/svg/good.svg'
import IconMedium from '@/assets/images/svg/medium.svg'
import IconBad from '@/assets/images/svg/bad.svg'
import IconVeryBad from '@/assets/images/svg/very-bad.svg'
import {
  last150,
  today,
} from '@/store/helpers'
import { YEAR_MONTH_DAY } from '@/libs/filterDate'
import { fieldRasioRetur, indicatorRatioRetur } from '@/views/pages/dashboard-admin-1.1/components/config'
import { toUpperCase } from '@/libs/helpers'

export default {
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BFormInput,
    BOverlay,
  },
  data() {
    return {
      title: 'History Rasio Retur Kecamatan',
      search: '',
      loading: true,
      indicator: indicatorRatioRetur,
      itemRasioRetur: [],
      fieldRasioRetur,
      toUpperCase,
    }
  },
  computed: {
    isDashboard() {
      return this.$route.path === '/admin-dashboard-komship'
    },
    wrapperTag() {
      return this.isDashboard ? 'BCard' : 'div'
    },
  },
  mounted() {
    this.getAnalyticRetur()
  },
  methods: {
    async getAnalyticRetur() {
      this.loading = true
      const params = {
        start_date: YEAR_MONTH_DAY(last150),
        end_date: YEAR_MONTH_DAY(today),
        search: this.search,
      }
      const url = '/komship/api/v1/admin/dashboard/analytic-retur-area/district'
      await this.$http_new
        .get(url, { params })
        .then(res => {
          const { data } = res.data
          this.itemRasioRetur = this.isDashboard && Array.isArray(data) ? data.slice(0, 10) : data
          this.loading = false
        })
        .catch(error => {
          this.$toast_error({ message: error.message || 'Terjadi Kesalahan' })
          this.loading = false
        })
    },
    handleRouterBack() {
      this.$router.back()
    },
    handleStatusIndicator(value) {
      if (value === 'Sangat Buruk') {
        return IconVeryBad
      }
      if (value === 'Buruk') {
        return IconBad
      }
      if (value === 'Sedang') {
        return IconMedium
      }
      if (value === 'Bagus') {
        return IconGood
      }
      if (value === 'Sangat Bagus') {
        return IconVeryGood
      }
      return IconVeryGood
    },
    handleClassStatus(value) {
      if (value === 'Sangat Bagus') {
        return 'lableStatusVeryGood'
      }
      if (value === 'Bagus') {
        return 'lableStatusGood'
      }
      if (value === 'Sedang') {
        return 'lableStatusMedium'
      }
      if (value === 'Buruk') {
        return 'lableStatusBad'
      }
      if (value === 'Sangat Buruk') {
        return 'lableStatusVeryBad'
      }
      return 'lableStatusVeryGood'
    },
    handleLabelPercentage(value) {
      if (value === 'Sangat Bagus') {
        return 'lablePercentageVeryGood'
      }
      if (value === 'Bagus') {
        return 'lablePercentageGood'
      }
      if (value === 'Sedang') {
        return 'lablePercentageMedium'
      }
      if (value === 'Buruk') {
        return 'lablePercentageBad'
      }
      if (value === 'Sangat Buruk') {
        return 'lablePercentageVeryBad'
      }
      return 'lablePercentageVeryGood'
    },
    searchDistrict: _.debounce(function search() {
      this.getAnalyticRetur()
    }, 1000),
  },
}
</script>
<style lang="scss" scoped src="../components/Ekspedisi.scss" />
